import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "icecream" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, "是否允许我们将您的设置信息存入到本地缓存，这将获得完美的体验", -1)
const _hoisted_3 = { class: "dialog-footer" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 取 消 ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 确 定 ")

import background from "@/components/background/background.vue";
import search from "@/components/search/search.vue";
import setting from "@/components/setting/setting.vue";
import data from "@/data/data";
import local from "@/utils/localData/local";
import { ElDialog, ElButton } from "element-plus";
import giteeUtil from "@/utils/giteeUtil";
import loading from "@/components/loading/loading.vue";

/**
 * 初始化
 */
import init from "./utils/localData/init";


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

init.go();

/**
 * 设置主题色
 */
document.documentElement.style.setProperty(
    "--themeColor",
    data.saveData.themeColor
);

const code = window.location.search.match(/[^\?code=].+/g);
if (code && !data.saveData.giteeToken) {
    giteeUtil.getGiteeToken(code[0]);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(background),
    _createVNode(search),
    _createVNode(setting),
    _createVNode(_unref(ElDialog), {
      title: "提示",
      modelValue: _unref(data).initDialog,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(data).initDialog) = $event)),
      width: "40%"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_3, [
          _createVNode(_unref(ElButton), {
            type: "primary",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(local).initSave(false)))
          }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          }),
          _createVNode(_unref(ElButton), {
            type: "primary",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(local).initSave(true)))
          }, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})